import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { Login, Dashboard } from "./Pages/";

const App = () => {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Navigate to="/login" />} />
				<Route path="/login" element={<Login />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="*" element={<Navigate to="/login" />} />
			</Routes>
		</Router>
	);
};

export default App;
